module.exports = __webpack_public_path__ + "static/media/gage-petal-4.4afe4f2f.jpg";